<template>
  <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
    <SmartLinkStandaloneElement :codename="typ.elements.text.codename">
        <div
            class="content-aligned-text"
            :class="{
                'text-left': data.textAlign === 'left',
                'text-center': data.textAlign === 'center',
                'text-right': data.textAlign === 'right',
                'text-justify': data.textAlign === 'justified',
                ['indent_' + data.indentation]: !!data.indentation
            }"
            >
            <RichText :value="data.content" />
        </div>
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>
</template>
<script setup lang="ts">
import type { ContentAlignedTextModel } from '~/models';
import { contentTypes } from '~/models';

const typ = contentTypes._content___aligned_text;

const props = defineProps<{ model: ContentAlignedTextModel }>();

const data = {
  content: props.model.elements.text.value,
  textAlign: props.model.elements.alignment.value[0]?.codename ?? 'left',
  indentation: props.model.elements.indentation?.value[0]?.codename ?? '',
}
</script>
